import React from "react";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import minusMarket from "../../images/minusMarket.png";
import minusVolume from "../../images/minusVolume.png";
import plusVolume from "../../images/plusVolume.png";
import plusMarket from "../../images/plusMarket.png";
import SortListSmall from "../Sortlist/SortListSmall";

const TopHalf = ({ data }) => {
  const formatMoney = (num) =>
    num.toLocaleString("en-US", { maximumFractionDigits: 0 });
  function formatPercentage(value) {
    return `${Math.abs(value.toFixed(2))}%`;
  }

  return (
    <div className="flex flex-col items-start py-4 px-4 w-full">
      <h1 className="font-bold md:text-2xl  text-gray-500">
        Top Tokenized Real Estate Tokens by Market Capitalization
      </h1>

      <p className="font-normal text-gray-500 text-xs md:text-sm mt-2">
        Listed below are the top crypto coins and tokens used for Tokenized Real
        Estate. They are listed in size by market capitalization. To reorder the
        list, simply click on one of the options - such as 24h or 7d - to see
        the sector from a different perspective.
      </p>

      {/* Scroll container */}
      <div className="w-full mt-4 overflow-x-auto no-scrollbar">
        <div className="inline-flex gap-4">
          <div
            style={{ width: "320px" }}
            className="shrink-0   w-[320px] h-24 bg-gray-900 shadow-sm rounded-md flex items-center justify-start px-8 py-2"
          >
            <div className="w-6/12 borderh-full flex flex-col justify-start items-center">
              <span className="text-xs text-gray-500 font-medium w-full">
                Market Cap
              </span>
              <span className="text-sm text-gray-400  font-bold my-1 w-full">
                {`$${formatMoney(data.marketCap)}`}
              </span>
              <div
                className={`text-xs ${
                  data.marketCapChange < 0 ? "text-red-500" : "text-green-500"
                } font-bold flex justify-start items-center w-full`}
              >
                {data.marketCapChange < 0 ? (
                  <IoMdArrowDropdown className="text-lg" />
                ) : (
                  <IoMdArrowDropup className="text-lg" />
                )}
                <span className="">
                  {formatPercentage(data.marketCapChange)}
                </span>
              </div>
            </div>
            <div className="w-6/12   h-full flex justify-center items-center">
              {data.marketCapChange < 0 ? (
                <img src={minusMarket} />
              ) : (
                <img src={plusMarket} />
              )}
            </div>
          </div>

          <div
            style={{ width: "300px" }}
            className="shrink-0   w-[320px] h-24 bg-gray-900 shadow-sm rounded-md flex items-center justify-center px-8 py-2"
          >
            <div className="w-6/12 borderh-full flex flex-col justify-start items-center">
              <span className="text-xs text-gray-500 font-medium w-full">
                Trading Volume
              </span>
              <span className="text-sm  text-gray-400  font-bold my-1 w-full">
                {`$${formatMoney(data.volume)}`}
              </span>
              <div
                className={`text-xs ${
                  data.volumeChange < 0 ? "text-red-500" : "text-green-500"
                } font-bold flex justify-start items-center w-full`}
              >
                {data.volumeChange < 0 ? (
                  <IoMdArrowDropdown className="text-lg" />
                ) : (
                  <IoMdArrowDropup className="text-lg" />
                )}
                <span className="">{formatPercentage(data.volumeChange)}</span>
              </div>
            </div>
            <div className="w-6/12   h-full flex justify-center items-center">
              {data.volumeChange < 0 ? (
                <img src={minusVolume} />
              ) : (
                <img src={plusVolume} />
              )}
            </div>
          </div>
        </div>
      </div>
      <SortListSmall />
    </div>
  );
};

export default TopHalf;
